import { Injectable } from '@angular/core';

const CURRENT_SESSION_KEY = 'CURRENT_SESSION';
export const SELECTED_LANG = 'SELECTED_LANG';
const PERM_PREFIX = 'perm_';
export const USER_VISITED_BEFORE = 'USER_VISITED_BEFORE';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  public setCurrentSession(userId: string, groupId: number) {
    const existingSessions = this.getCurrentSessions();
    const newSession = { userId, groupId };
    const exists = existingSessions?.some((session) => session.userId === userId);

    if (!exists) {
      existingSessions.push(newSession);
      localStorage.setItem(CURRENT_SESSION_KEY, JSON.stringify(existingSessions));
    }
  }

  public getCurrentSessions(): { userId: string; groupId: number }[] {
    const storedSessions = localStorage.getItem(CURRENT_SESSION_KEY);
    return storedSessions ? JSON.parse(storedSessions) : [];
  }

  public getCurrentSession(userId: string): { userId: string; groupId: number } | null {
    const sessions = this.getCurrentSessions();
    if (sessions.length > 0) {
      const session = sessions.find((session) => session.userId === userId);
      return session || null;
    }
    return null;
  }

  public removeCurrentSession(userId?: string, groupId?: number) {
    if (userId && groupId) {
      const sessions = this.getCurrentSessions();
      const filteredSessions = sessions.filter(
        (session) => !(session.userId === userId && session.groupId === groupId)
      );
      localStorage.setItem(CURRENT_SESSION_KEY, JSON.stringify(filteredSessions));
    } else {
      localStorage.removeItem(CURRENT_SESSION_KEY);
    }
  }

  public setUserScopedItem(key: string, value: any, userId: string) {
    // User scoped items should not be cleared on session refresh, as they should exist between sessions. Mark them as 'perm' to not remove
    localStorage.setItem(PERM_PREFIX + key + '_' + userId, JSON.stringify(value));
  }

  public getUserScopedItem(key: string, userId: string) {
    const item = localStorage.getItem(PERM_PREFIX + key + '_' + userId);
    return item ? JSON.parse(item) : null;
  }

  public setPersistentItem(key: string, value: any) {
    localStorage.setItem(PERM_PREFIX + key, JSON.stringify(value));
  }

  public getPersistentItem(key: string) {
    const item = localStorage.getItem(PERM_PREFIX + key);
    return item ? JSON.parse(item) : null;
  }

  public clear(): void {
    for (const key in localStorage) {
      if (!key.startsWith(PERM_PREFIX)) {
        localStorage.removeItem(key);
      }
    }
  }
}
